import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { EGiftCardsEventName, IGiftCardsSelectedEvent } from './types';

export { EGiftCardsEventSource } from './types';

export const trackGiftCardsSelectedEvent = (event: IGiftCardsSelectedEvent) => {
  trackEventV2(EGiftCardsEventName.GIFT_CARDS_SELECTED, EProjectSection.MARKETPLACE, { ...event });
};
